import {
  Build,
  DashboardRounded as DashboardRoundedIcon,
  BusinessRounded as BusinessRoundedIcon,
  RocketLaunch as DataRequestIcon,
  CloudDownloadRounded as ExportsIcon,
  PeopleRounded as PeopleRoundedIcon,
  NetworkCheck as DataAlertsIcon,
  CloudSync as DeploymentIcon,
  MenuBook as DocsIcon,
  Assignment as ModelIcon,
} from '@mui/icons-material';
import { AUTH_LEVELS } from '../../redux/constants/roles';

const DEFAULT_NAV_ITEMS = [
  {
    text: 'Live System',
    items: [
      {
        to: '/explore/buildings',
        text: 'Buildings',
        icon: BusinessRoundedIcon,
      },
      {
        to: '/deployments',
        text: 'Deployments',
        icon: DeploymentIcon,
      },
      {
        to: '/data-alerts',
        text: 'Data Alerts',
        icon: DataAlertsIcon,
      },
      {
        to: '/dashboard',
        text: 'Dashboard',
        icon: DashboardRoundedIcon,
      },
    ],
  },
  {
    text: 'Configuration',
    items: [
      {
        to: '/buildings/new',
        text: 'Launcher',
        icon: DataRequestIcon,
        authLevel: AUTH_LEVELS.ORG_ADMIN,
      },
      {
        to: '/staging',
        text: 'Staging',
        icon: Build,
        authLevel: AUTH_LEVELS.ORG_ADMIN,
      },
    ],
  },
  {
    text: 'Data',
    items: [
      {
        to: '/data-model',
        text: 'Data Model',
        icon: ModelIcon,
      },
      {
        to: '/exports',
        text: 'Data Export',
        icon: ExportsIcon,
      },
      {
        to: '/docs',
        text: 'API & Docs',
        icon: DocsIcon,
      },
    ],
  },
  {
    text: 'Account Admin',
    items: [
      {
        to: '/users',
        text: 'Users',
        authLevel: AUTH_LEVELS.ORG_ADMIN,
        icon: PeopleRoundedIcon,
      },
    ],
  },
];

export default DEFAULT_NAV_ITEMS;
